import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.47 1.24125L14.77 0.53125L8.00003 7.29125L1.24003 0.53125L0.530029 1.24125L7.29003 8.00125L0.530029 14.7712L1.24003 15.4712L8.00003 8.71125L14.77 15.4712L15.47 14.7712L8.71003 8.00125L15.47 1.24125Z",
  fill: "#1F1F1F"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }